
























import Vue, { PropType } from 'vue';
import {
  BoothData,
} from 'mostra';

export default Vue.extend({
  name: 'GBoothTemplateForm',
  props: {
    booth: {
      type: Object as PropType<BoothData>,
      required: true,
    },
    onSelectTemplate: {
      type: Function as PropType<() => void>,
      default: null,
    },
  },
  methods: {
  },
});
